export default function redirectRegistration({ input, services }) {
  services.router.redirect(`/registration/${input.currentPage}`)
}



// WEBPACK FOOTER //
// ./src/modules/login/actions/redirectRegistration.js